import { render, staticRenderFns } from "./Medicine.vue?vue&type=template&id=2427d6c1&scoped=true&"
import script from "./Medicine.vue?vue&type=script&lang=js&"
export * from "./Medicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427d6c1",
  null
  
)

export default component.exports